const DocNameCard = ({ document, clickHandler, isActive }) => {

  const cardClass = isActive ? "active-card" : "";
  return (
    <div
      onClick={() => clickHandler?.(document)}
      className={`shadow card border-0 rounded-3 p-3 mb-4 ${cardClass}`}
      style={{
        cursor: 'pointer',
        minHeight: '80px',
        height: '100%',
      }}
    >
      <div className="d-flex flex-column justify-content-center h-100">
        <h6 className={`mb-0 mt-2 lh-base`}>
          {document?.documentName}
        </h6>
      </div>
    </div>
  );
};

export default DocNameCard;
